import React, { useEffect, useState } from "react";
import i18n from "i18next";

// Fabric Imports

import AcademyContentDE from "./AcademyContentDE";
import AcademyContentEN from "./AcademyContentEN";
import "./Academy.scss";

import { helperMethods } from "../../helpers/helperMethods";
import { StackShim } from "@fluentui/react-migration-v8-v9";
import {
  ArrowDownloadFilled,
  BookTemplateRegular,
  HatGraduationRegular,
  IosArrowRtl24Regular,
  SendRegular,
} from "@fluentui/react-icons";
import {
  Button,
  createTableColumn,
  Link,
  Tab,
  TableCellLayout,
  TableColumnDefinition,
  TabList,
  Text,
} from "@fluentui/react-components";
import { useNavigate } from "react-router-dom";
import LuebPagedDataGrid from "../../Controls/LuebPagedDataGrid";
import { fetchWrapper } from "../../helpers/fetchwrapper";
import { baseUrl } from "../../helpers/constants";
import Header from "../Layout/Header";
import useWindowSize from "../../helpers/useWindowSize";
import HeaderTextAnimation from "../Layout/HeaderTextAnimation";

interface IAcademyProps {}

interface AcademyCatalog {
  urlName: string;
  name: string;
  art: string;
  durationEn: string;
  participantsEn: string;
  durationDe: string;
  participantsDe: string;
}

function AcademyCatalog(props: IAcademyProps) {
  const [selectedCatalog, setSelectedCatalog] = useState<string>();
  const [selectedTab, setSelectedTab] = useState<string>("schraubtechnik");

  useEffect(() => {
    helperMethods.addAccessedModuleCountValue("Academy");
  }, []);

  const splitText = i18n.t<string>("academyDescription").split("\n");
  const navigate = useNavigate();
  const windowSize = useWindowSize();
  const catalogListe: AcademyCatalog[] = [
    {
      urlName: "LSP3APPLICATIONWORKSHOP",
      name: "L.SP3 APPLICATION WORKSHOP",
      art: "schraubtechnik",
      durationEn: "1,5 to 2 days",
      durationDe: "1,5 bis 2 Tage",
      participantsEn: "1 to 6",
      participantsDe: "1 bis 6",
    },
    {
      urlName: "LSP3INSTALLATIONWORKSHOP",
      name: "L.SP3 INSTALLATION WORKSHOP",
      art: "schraubtechnik",
      durationEn: "5 hours",
      durationDe: "5 Stunden",
      participantsEn: "1 to 6",
      participantsDe: "1 bis 6",
    },
    {
      urlName: "LSP3OPERATORWORKSHOP",
      name: "L.SP3 OPERATOR WORKSHOP",
      art: "schraubtechnik",
      durationEn: "3 hours",
      durationDe: "3 Stunden",
      participantsEn: "1 to 6",
      participantsDe: "1 bis 6",
    },
    {
      urlName: "LSP3MAINTENANCEWORKSHOP",
      name: "L.SP3 MAINTENANCE WORKSHOP",
      art: "schraubtechnik",
      durationEn: "1 day",
      durationDe: "1 Tag",
      participantsEn: "1 to 4",
      participantsDe: "1 bis 4",
    },
    {
      urlName: "CUSTOMIZEDWORKSHOP",
      name: "CUSTOMIZED WORKSHOP",
      art: "schraubtechnik",
      durationEn: "1 to 2 days",
      durationDe: "1 bis 2 Tage",
      participantsEn: "1 to 4",
      participantsDe: "1 bis 4",
    },
    {
      urlName: "LADUAPPLICATIONWORKSHOP",
      name: "L.ADU APPLICATION WORKSHOP",
      art: "bohrtechnik",
      durationEn: "1 days",
      durationDe: "1 Tag",
      participantsEn: "1 to 6",
      participantsDe: "1 bis 6",
    },
    {
      urlName: "LADUINSTALLATIONWORKSHOP",
      name: "L.ADU INSTALLATION WORKSHOP",
      art: "bohrtechnik",
      durationEn: "5 hours",
      durationDe: "5 Stunden",
      participantsEn: "1 to 6",
      participantsDe: "1 bis 6",
    },
    {
      urlName: "LADUOPERATORWORKSHOP",
      name: "L.ADU OPERATOR WORKSHOP",
      art: "bohrtechnik",
      durationEn: "3 hours",
      durationDe: "3 Stunden",
      participantsEn: "1 to 6",
      participantsDe: "1 bis 6",
    },
    {
      urlName: "LADUMAINTENANCEWORKSHOP",
      name: "L.ADU MAINTENANCE WORKSHOP",
      art: "bohrtechnik",
      durationEn: "1 to 2 days",
      durationDe: "1 bis 2 Tage",
      participantsEn: "1 to 4",
      participantsDe: "1 bis 4",
    },
    {
      urlName: "LADUPROGRAMMINGWORKSHOP",
      name: "L.ADU PROGRAMMING WORKSHOP",
      art: "bohrtechnik",
      durationEn: "1 to 2 days",
      durationDe: "1 bis 2 Tage",
      participantsEn: "1 to 4",
      participantsDe: "1 bis 4",
    },
  ];

  const columns: TableColumnDefinition<AcademyCatalog>[] = [
    createTableColumn<AcademyCatalog>({
      columnId: "name",

      renderHeaderCell: () => "Name",
      renderCell: (item) => (
        <TableCellLayout>
          <Link
            onClick={() => {
              navigate("/academy/catalog?name=" + item.urlName);
              setSelectedCatalog(item.urlName);
            }}
          >
            {item.name}
          </Link>
        </TableCellLayout>
      ),
    }),
    createTableColumn<AcademyCatalog>({
      columnId: "duration",

      renderHeaderCell: () =>
        i18n.language.includes("de") ? "Dauer" : "Duration",
      renderCell: (item) => (
        <TableCellLayout>
          {i18n.language.includes("de") ? item.durationDe : item.durationEn}
        </TableCellLayout>
      ),
    }),
    createTableColumn<AcademyCatalog>({
      columnId: "participants",

      renderHeaderCell: () =>
        i18n.language.includes("de")
          ? "Teilnehmerzahl"
          : "Number of participants",
      renderCell: (item) => (
        <TableCellLayout>
          {i18n.language.includes("de")
            ? item.participantsDe
            : item.participantsEn}
        </TableCellLayout>
      ),
    }),
  ];

  useEffect(() => {
    if (window.location) {
      if (window.location.search) {
        var search = window.location.search.split("=");
        var name = search[1];
        if (name) {
          setSelectedCatalog(name);
        }
      }
    }
  }, [window.location.search]);

  return (
    <>
      <Header
        HTMLElement={
          <StackShim horizontal verticalAlign="center">
            <Button
              style={{ paddingLeft: "0px" }}
              size="small"
              onClick={() => {
                navigate("/academy");
              }}
              appearance="transparent"
            >
              <HatGraduationRegular fontSize={24} color="#ff6600" />
            </Button>
            <IosArrowRtl24Regular color="#ff6600" />
            {(windowSize.width > 1250 ||
              windowSize.width < 1024 ||
              !selectedCatalog) && (
              <Button
                icon={<BookTemplateRegular fontSize={24} color="#ff6600" />}
                size="large"
                appearance="subtle"
                onClick={() => {
                  navigate("/academy/catalog");
                  setSelectedCatalog("");
                }}
              >
                <HeaderTextAnimation text={i18n.t<string>("academyCatalog")} />
              </Button>
            )}
            {windowSize.width < 1251 &&
              windowSize.width > 1024 &&
              selectedCatalog && (
                <Button
                  size="small"
                  onClick={() => {
                    navigate("/academy/catalog");
                    setSelectedCatalog("");
                  }}
                  appearance="transparent"
                >
                  <BookTemplateRegular fontSize={24} color="#ff6600" />
                </Button>
              )}
            {selectedCatalog && (
              <div style={{ display: "flex", alignItems: "center" }}>
                <IosArrowRtl24Regular color="#ff6600" />
                <Button size="large" appearance="subtle">
                  <HeaderTextAnimation
                    text={
                      catalogListe.find((x) => x.urlName == selectedCatalog)
                        ?.name ?? ""
                    }
                  />
                </Button>
              </div>
            )}
          </StackShim>
        }
      />
      <div>
        <div className="lueb-InnerContentBlockPadding2px">
          {!selectedCatalog && (
            <Button
              icon={<SendRegular />}
              as="a"
              appearance="subtle"
              href="mailto:service@luebbering.de?subject=eAcademy General Training"
            >
              {i18n.language.includes("de")
                ? "Schulung anfragen"
                : "Request training"}
            </Button>
          )}
          {selectedCatalog == "LSP3APPLICATIONWORKSHOP" && (
            <Button
              icon={<SendRegular />}
              as="a"
              appearance="subtle"
              href="mailto:service@luebbering.de?subject=eAcademy L.SP3 Application Workshop"
            >
              Schulungstermine anfragen
            </Button>
          )}
          {selectedCatalog == "LSP3INSTALLATIONWORKSHOP" && (
            <Button
              icon={<SendRegular />}
              as="a"
              appearance="subtle"
              href="mailto:service@luebbering.de?subject=eAcademy L.SP3 Installation Workshop"
            >
              Schulungstermine anfragen
            </Button>
          )}
          {selectedCatalog == "LSP3OPERATORWORKSHOP" && (
            <Button
              icon={<SendRegular />}
              as="a"
              appearance="subtle"
              href="mailto:service@luebbering.de?subject=eAcademy L.SP3 Operator Workshop"
            >
              Schulungstermine anfragen
            </Button>
          )}{" "}
          {selectedCatalog == "LSP3MAINTENANCEWORKSHOP" && (
            <Button
              icon={<SendRegular />}
              as="a"
              appearance="subtle"
              href="mailto:service@luebbering.de?subject=eAcademy L.SP3 Maintenance Workshop"
            >
              Schulungstermine anfragen
            </Button>
          )}{" "}
          {selectedCatalog == "CUSTOMIZEDWORKSHOP" && (
            <Button
              icon={<SendRegular />}
              as="a"
              appearance="subtle"
              href="mailto:service@luebbering.de?subject=eAcademy Customized Workshop"
            >
              Schulungstermine anfragen
            </Button>
          )}{" "}
          {selectedCatalog == "LADUAPPLICATIONWORKSHOP" && (
            <Button
              icon={<SendRegular />}
              as="a"
              appearance="subtle"
              href="mailto:service@luebbering.de?subject=eAcademy L.ADU Application Workshop"
            >
              Schulungstermine anfragen
            </Button>
          )}{" "}
          {selectedCatalog == "LADUINSTALLATIONWORKSHOP" && (
            <Button
              icon={<SendRegular />}
              as="a"
              appearance="subtle"
              href="mailto:service@luebbering.de?subject=eAcademy L.ADU Installation Workshop"
            >
              Schulungstermine anfragen
            </Button>
          )}{" "}
          {selectedCatalog == "LADUOPERATORWORKSHOP" && (
            <Button
              icon={<SendRegular />}
              as="a"
              appearance="subtle"
              href="mailto:service@luebbering.de?subject=eAcademy L.ADU Operator Workshop"
            >
              Schulungstermine anfragen
            </Button>
          )}{" "}
          {selectedCatalog == "LADUMAINTENANCEWORKSHOP" && (
            <Button
              icon={<SendRegular />}
              as="a"
              appearance="subtle"
              href="mailto:service@luebbering.de?subject=eAcademy L.ADU Maintenance Workshop"
            >
              Schulungstermine anfragen
            </Button>
          )}{" "}
          {selectedCatalog == "LADUPROGRAMMINGWORKSHOP" && (
            <Button
              icon={<SendRegular />}
              as="a"
              appearance="subtle"
              href="mailto:service@luebbering.de?subject=eAcademy LADU Programming Workshop"
            >
              Schulungstermine anfragen
            </Button>
          )}
          <Button
            appearance="subtle"
            icon={<ArrowDownloadFilled />}
            onClick={() =>
              fetchWrapper
                .downloadFile(
                  baseUrl + i18n.language.includes("de")
                    ? "/api/documents/GetDocumentFromPath?path=/DOKUMENTE/DIVERSE/LSMR_BROSCHUERE_DE.PDF"
                    : "/api/documents/GetDocumentFromPath?path=/DOKUMENTE/DIVERSE/LSMR_Brochure_EN.pdf",
                )
                .then((blob) => {
                  // Create blob link to download
                  const url = window.URL.createObjectURL(new Blob([blob]));
                  const link = document.createElement("a");
                  link.href = url;
                  link.setAttribute(
                    "download",
                    i18n.language.includes("de")
                      ? "LSMR_BROSCHUERE_DE.PDF"
                      : "LSMR_Brochure_EN.pdf",
                  );

                  // Append to html link element page
                  document.body.appendChild(link);

                  // Start download
                  link.click();

                  // Clean up and remove the link
                  link.parentNode?.removeChild(link);

                  return true;
                })
            }
            target="_blank"
          >
            {i18n.language.includes("de")
              ? " Download L.SMR Broschüre (PDF)"
              : "Download L.SMR brochure (PDF)"}
          </Button>
        </div>
        <div>
          {!selectedCatalog && (
            <div>
              <div className="lueb-ContentBlock">
                {" "}
                <h4>{i18n.t<string>("academyTitle")}</h4>
                {splitText.map((item) => (
                  <Text className="lueb-MarginBottom10" block>
                    {item}
                  </Text>
                ))}
              </div>{" "}
              <div>
                <TabList selectedValue={selectedTab}>
                  <Tab
                    onClick={() => {
                      setSelectedTab("schraubtechnik");
                    }}
                    value={"schraubtechnik"}
                  >
                    {i18n.t<string>("schraubtechnik")}
                  </Tab>
                  <Tab
                    onClick={() => {
                      setSelectedTab("bohrtechnik");
                    }}
                    value={"bohrtechnik"}
                  >
                    {i18n.t<string>("bohrtechnik")}
                  </Tab>
                </TabList>{" "}
              </div>
              {selectedTab && (
                <div className="lueb-ContentBlock">
                  <LuebPagedDataGrid
                    items={catalogListe.filter((x) => x.art == selectedTab)}
                    columns={columns}
                    resizableColumns
                    sortable
                    columnSizingOptions={{
                      name: {
                        minWidth: 300,
                        defaultWidth: 400,
                      },
                      zeitraum: {
                        minWidth: 200,
                        defaultWidth: 200,
                      },
                      trainer: {
                        minWidth: 200,
                        defaultWidth: 300,
                      },
                    }}
                  />
                </div>
              )}
            </div>
          )}
          {selectedCatalog && i18n.language.includes("de") && (
            <AcademyContentDE name={selectedCatalog} />
          )}
          {selectedCatalog && !i18n.language.includes("de") && (
            <AcademyContentEN name={selectedCatalog} />
          )}
        </div>
      </div>
    </>
  );
}

export default AcademyCatalog;
